#import '../../../../shared/graphql/fragments/lead-step-fragment.graphql'

mutation SkipStepForLead($input: SkipStepInput!) {
    skipStep(input: $input) {
        step {
            ...LeadStepFragment
        }
    }
}
